import React, { useState } from "react";
import Accordion from "@material-ui/core/Accordion";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

import "./Disciplines.css";

import Checkbox from "./Checkboxes";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "1% !important",
    background: "#ffffff",
    border: "1px solid #d7d7d7",
    boxSizing: "border-box",
    boxShadow: "0px 4px 4px rgb(0 0 0 / 25%) !important",
    borderRadius: "5px",
  },
  expandIcon: {
    color: "#aeaeb0",
  },
}));

export default function Disciplines({
  selectAllCheckBoxes,
  criterialist,
  toggleCheckBoxChange,
}) {
  const classes = useStyles();
  const [expanded, setEexpanded] = useState(false);

  return (
    <div className="row">
      <Accordion
        className={classes.root}
        expanded={expanded}
        onChange={() => setEexpanded(!expanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
        >
          <Typography>
            <span className="disciplinestext"> Choose Disciplines </span>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="common-padding wrapper">
            {criterialist.map((list, index) => {
              return (
                <Checkbox
                  key={list.id}
                  value={index}
                  toggleChange={() => toggleCheckBoxChange(list, index)}
                  criteriaName={list.name}
                  checkedFlag={list.isChecked}
                />
              );
            })}
          </div>
        </AccordionDetails>
      </Accordion>
      {/* select all code
        <div>
          <label className="checkborder">
            <input
              type="checkbox"
              id="sel-all-desc"
              onChange={(e) => selectAllCheckBoxes(e)}
            />
            <span className="selectall-checkbox" />
            <span id="selectall-fontStyle">Select All</span>
          </label>
        </div>
      */}
      <hr className="zero-padding line btm-line" />
    </div>
  );
}
